import * as React from "react";
import * as uuid from "uuid";

import { DrawerViewModel, DrawerViewProps } from "../../Common";

import {
  useDrawerGiftcardHelp,
  useDrawerGiftcardHelp_asController,
} from "../providers";

export const DrawerFragment_GiftcardHelp_ViewModel: DrawerViewProps["useDrawerViewModel"] =
  () => {
    const { drawerShouldBePresenting } = useDrawerGiftcardHelp();
    const { handleClose: drawerGiftcardHelp_handleClose } =
      useDrawerGiftcardHelp_asController();

    const this_guid = React.useMemo(() => {
      return uuid.v4();
    }, []);

    const handleClose = React.useCallback(() => {
      drawerGiftcardHelp_handleClose();
    }, [drawerGiftcardHelp_handleClose]);

    const present = React.useMemo(() => {
      return drawerShouldBePresenting;
    }, [drawerShouldBePresenting]);

    const className = React.useMemo(() => {
      return `bbnt-checkout-2022 giftcard-help`;
    }, []);

    const value: DrawerViewModel = React.useMemo(
      () => ({
        guid: this_guid,
        present,
        className,
        handleClose,
      }),
      [this_guid, present, className, handleClose]
    );
    return value;
  };
